import useDifferentGraphViewsBtns from "./useDifferentGraphViewsBtns";
import useDistributionTypeBtns from "./useDistributionTypeBtns";
import useNormalDistributionFields from './useNormalDistributionFields'
import constants from './constants'
import useFields from "./useFIelds";
import useColumns from "./useColumns";

export default { constants, useColumns, useFields, useNormalDistributionFields, useDifferentGraphViewsBtns, useDistributionTypeBtns }